package com.flowyride.feature.planner.ui

import kotlin.math.roundToInt
import kotlin.math.roundToLong

/** "850 m", "12,4 km", "107 km". */
internal fun formatDistance(meters: Double): String = when {
    meters < 1_000 -> "${meters.roundToInt()} m"
    meters < 20_000 -> {
        val tenths = (meters / 100).roundToLong()
        "${tenths / 10},${tenths % 10} km"
    }
    else -> "${(meters / 1_000).roundToLong()} km"
}

/** "45 min", "1 h 05", "12 h". */
internal fun formatDuration(seconds: Double): String {
    val totalMinutes = (seconds / 60).roundToLong()
    val hours = totalMinutes / 60
    val minutes = totalMinutes % 60
    return when {
        hours == 0L -> "$minutes min"
        minutes == 0L -> "$hours h"
        else -> "$hours h ${minutes.toString().padStart(2, '0')}"
    }
}
